import { render, staticRenderFns } from "./SHImage.vue?vue&type=template&id=835012ca&scoped=true&"
import script from "./SHImage.vue?vue&type=script&lang=js&"
export * from "./SHImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835012ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('835012ca')) {
      api.createRecord('835012ca', component.options)
    } else {
      api.reload('835012ca', component.options)
    }
    module.hot.accept("./SHImage.vue?vue&type=template&id=835012ca&scoped=true&", function () {
      api.rerender('835012ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/components/SHImage.vue"
export default component.exports